import { SxProps } from '@mui/material';
import zeplinColor from 'theme/Color';

const styles: Record<string, SxProps> = {
  optionMenu: {
    padding: '3px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    ':hover': {
      backgroundColor: zeplinColor.Neutral5,
      cursor: 'pointer',
    },
  },
};

export default styles;
